import { HTTP } from './axios'
import fromApi from './map-to-frontend'
import session from '../utilities/session.js'

const authToken = () => {
  return session.readToken()
}

const createCompanySubscription = (jsConn) => {
  // TODO move this to the map-to-frontend module
  jsConn.apiParams = {...jsConn.formParams}

  return HTTP.post('/company_subscriptions', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.response = response
      jsConn.apiCallStatus = 'success'
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.error = e
      jsConn.apiCallStatus = 'error'
      return Promise.resolve(jsConn)
    })
}

const getDefaultCompanyData = (jsConn) => {
  return HTTP.get('/default_data')
    .then(response => {
      jsConn.response = response
      jsConn.apiCallStatus = 'success'
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.error = e
      jsConn.apiCallStatus = 'error'
      return Promise.resolve(jsConn)
    })
}

const getUserCompanyData = (jsConn) => {
  return HTTP.get('/user_data', { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.response = response
      jsConn.apiCallStatus = 'success'
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.error = e
      jsConn.apiCallStatus = 'error'
      return Promise.resolve(jsConn)
    })
}

const verifyEmail = (jsConn) => {
  jsConn.apiParams = fromApi.emailVerificationToApi(jsConn.formParams)
  return HTTP.post('/email_verification', jsConn.apiParams)
    .then(response => {
      jsConn.response = response
      jsConn.apiCallStatus = 'success'
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.error = e
      jsConn.apiCallStatus = 'error'
      return Promise.resolve(jsConn)
    })
}

const signInUser = (jsConn) => {
  return HTTP.post('/sessions', {
    session: {
      email: jsConn.formParams.email,
      password: jsConn.formParams.password
    }
  })
    .then(response => {
      jsConn.response = response
      jsConn.apiCallStatus = 'success'
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.toRoutePath = '/sign-in'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateSession = (jsConn) => {
  const token = jsConn.apiParams['token']
  return HTTP.put('/sessions/' + token, { token: token }, { headers: { Authorization: `Bearer ${token}` } })
    .then(response => {
      jsConn.response = response
      jsConn.apiCallStatus = 'success'
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.toRoutePath = '/sign-in'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteSession = (token) => {
  return HTTP.delete('/sessions/' + token, { token: token }, { headers: { Authorization: `Bearer ${token}` } })
}

const createUser = (jsConn) => {
  jsConn.apiParams = fromApi.userToApi(jsConn.formParams)
  return HTTP.post('/user_accounts', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.response = response
      jsConn.apiCallStatus = 'success'
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.toRoutePath = '/sign-in'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createFertilizer = (jsConn) => {
  jsConn.apiParams = fromApi.fertilizerToApi(jsConn.formParams)
  return HTTP.post('/fertilizers', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      // process the response
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.fertilizerToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateFertilizer = (jsConn) => {
  jsConn.apiParams = fromApi.fertilizerToApi(jsConn.formParams)
  return HTTP.patch('/fertilizers/' + jsConn.apiParams['fertilizer']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.fertilizerToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteFertilizer = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/fertilizers/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createOtherExpense = (jsConn) => {
  jsConn.apiParams = fromApi.otherExpenseToApi(jsConn.formParams)
  return HTTP.post('/other_expenses', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      // process the response
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.otherExpenseToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateOtherExpense = (jsConn) => {
  jsConn.apiParams = fromApi.otherExpenseToApi(jsConn.formParams)
  return HTTP.patch('/other_expenses/' + jsConn.apiParams['other_expense']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.otherExpenseToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteOtherExpense = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/other_expenses/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createChemical = (jsConn) => {
  jsConn.apiParams = fromApi.chemicalToApi(jsConn.formParams)
  return HTTP.post('/chemicals', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      // process the response
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.chemicalToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateChemical = (jsConn) => {
  jsConn.apiParams = fromApi.chemicalToApi(jsConn.formParams)
  return HTTP.patch('/chemicals/' + jsConn.apiParams['chemical']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.chemicalToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteChemical = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/chemicals/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCustomRate = (jsConn) => {
  jsConn.apiParams = fromApi.customRateToApi(jsConn.formParams)
  return HTTP.post('/custom_rates', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.customRateToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCustomRate = (jsConn) => {
  jsConn.apiParams = fromApi.customRateToApi(jsConn.formParams)
  return HTTP.patch('/custom_rates/' + jsConn.apiParams['custom_rate']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.customRateToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCustomRate = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/custom_rates/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createSeed = (jsConn) => {
  jsConn.apiParams = fromApi.seedToApi(jsConn.formParams)
  return HTTP.post('/seeds', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      // process the response
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.seedToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateSeed = (jsConn) => {
  jsConn.apiParams = fromApi.seedToApi(jsConn.formParams)
  return HTTP.patch('/seeds/' + jsConn.apiParams['seed']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.seedToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteSeed = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/seeds/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createIrrigation = (jsConn) => {
  jsConn.apiParams = fromApi.irrigationToApi(jsConn.formParams)
  return HTTP.post('/irrigations', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.irrigationToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(e)
    })
}

const updateIrrigation = (jsConn) => {
  jsConn.apiParams = fromApi.irrigationToApi(jsConn.formParams)
  return HTTP.patch('/irrigations/' + jsConn.apiParams['irrigation']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.irrigationToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(e)
    })
}

const deleteIrrigation = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/irrigations/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCommodity = (jsConn) => {
  jsConn.apiParams = fromApi.commodityToApi(jsConn.formParams)
  return HTTP.post('/commodities', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      // process the response
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.commodityToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCommodity = (jsConn) => {
  jsConn.apiParams = fromApi.commodityToApi(jsConn.formParams)
  return HTTP.patch('/commodities/' + jsConn.apiParams['commodity']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.commodityToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCommodity = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/commodities/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(e)
    })
}

const createOtherIncome = (jsConn) => {
  jsConn.apiParams = fromApi.otherIncomeToApi(jsConn.formParams)
  return HTTP.post('/other_incomes', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      // process the response
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.otherIncomeToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateOtherIncome = (jsConn) => {
  jsConn.apiParams = fromApi.otherIncomeToApi(jsConn.formParams)
  return HTTP.patch('/other_incomes/' + jsConn.apiParams['other_income']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.otherIncomeToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteOtherIncome = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/other_incomes/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCrop = (jsConn) => {
  jsConn.apiParams = fromApi.cropToApi(jsConn.formParams)

  return HTTP.post('/crops', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      // process the response
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCrop = (jsConn) => {
  jsConn.apiParams = fromApi.cropToApi(jsConn.formParams)
  return HTTP.patch('/crops/' + jsConn.apiParams['crop']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.reject(jsConn)
    })
}

const deleteCrop = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops/' + jsConn.apiParams['id'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropCommodity = (jsConn) => {
  jsConn.apiParams = fromApi.cropCommodityToApi(jsConn.formParams)

  return HTTP.post('/crops_commodities', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropCommodityToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropCommodity = (jsConn) => {
  jsConn.apiParams = fromApi.cropCommodityUpdateProductionToApi(jsConn.formParams)

  return HTTP.patch('/crops_commodities/' + jsConn.apiParams['crop_commodity']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropCommodityToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropCommodity = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_commodities/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropOtherIncome = (jsConn) => {
  jsConn.apiParams = fromApi.cropOtherIncomeToApi(jsConn.formParams)

  return HTTP.post('/crops_other_incomes', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropOtherIncomeToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropOtherIncome = (jsConn) => {
  jsConn.apiParams = fromApi.cropOtherIncomeUpdateQuantityToApi(jsConn.formParams)

  return HTTP.patch('/crops_other_incomes/' + jsConn.apiParams['crop_other_income']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropOtherIncomeToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropOtherIncome = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_other_incomes/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropOtherExpense = (jsConn) => {
  jsConn.apiParams = fromApi.cropOtherExpenseToApi(jsConn.formParams)

  return HTTP.post('/crops_other_expenses', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropOtherExpenseToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropOtherExpense = (jsConn) => {
  jsConn.apiParams = fromApi.cropOtherExpenseUpdateQuantityToApi(jsConn.formParams)

  return HTTP.patch('/crops_other_expenses/' + jsConn.apiParams['crop_other_expense']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropOtherExpenseToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropOtherExpense = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_other_expenses/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropSeed = (jsConn) => {
  jsConn.apiParams = fromApi.cropSeedToApi(jsConn.formParams)

  return HTTP.post('/crops_seeds', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropSeedToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropSeed = (jsConn) => {
  jsConn.apiParams = fromApi.cropSeedUpdateSeedingRateToApi(jsConn.formParams)

  return HTTP.patch('/crops_seeds/' + jsConn.apiParams['crop_seed']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropSeedToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropSeed = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_seeds/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropCustomRate = (jsConn) => {
  jsConn.apiParams = fromApi.cropCustomRateToApi(jsConn.formParams)
  return HTTP.post('/crops_custom_rates', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropCustomRateToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropCustomRate = (jsConn) => {
  jsConn.apiParams = fromApi.cropCustomRateUpdateQuantityToApi(jsConn.formParams)

  return HTTP.patch('/crops_custom_rates/' + jsConn.apiParams['crop_custom_rate']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropCustomRateToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropCustomRate = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_custom_rates/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropChemical = (jsConn) => {
  jsConn.apiParams = fromApi.cropChemicalToApi(jsConn.formParams)

  return HTTP.post('/crops_chemicals', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropChemicalToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropChemical = (jsConn) => {
  jsConn.apiParams = fromApi.cropChemicalUpdateApplicationRateToApi(jsConn.formParams)

  return HTTP.patch('/crops_chemicals/' + jsConn.apiParams['crop_chemical']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropChemicalToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropChemical = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_chemicals/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropFertilizer = (jsConn) => {
  jsConn.apiParams = fromApi.cropFertilizerToApi(jsConn.formParams)

  return HTTP.post('/crops_fertilizers', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropFertilizerToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropFertilizer = (jsConn) => {
  jsConn.apiParams = fromApi.cropFertilizerUpdateApplicationRateToApi(jsConn.formParams)

  return HTTP.patch('/crops_fertilizers/' + jsConn.apiParams['crop_fertilizer']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropFertilizerToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropFertilizer = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_fertilizers/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const createCropIrrigation = (jsConn) => {
  jsConn.apiParams = fromApi.cropIrrigationToApi(jsConn.formParams)

  return HTTP.post('/crops_irrigations', jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropIrrigationToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const updateCropIrrigation = (jsConn) => {
  jsConn.apiParams = fromApi.cropIrrigationUpdateQuantityToApi(jsConn.formParams)

  return HTTP.patch('/crops_irrigations/' + jsConn.apiParams['crop_irrigation']['id'], jsConn.apiParams, { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      jsConn.dataForStore = fromApi.cropIrrigationToStore(jsConn.response['data'])
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

const deleteCropIrrigation = (jsConn) => {
  jsConn.apiParams = jsConn.formParams
  return HTTP.delete('/crops_irrigations/' + jsConn.apiParams['itemId'], { headers: { Authorization: `Bearer ${authToken()}` } })
    .then(response => {
      jsConn.apiCallStatus = 'success'
      jsConn.response = response
      return Promise.resolve(jsConn)
    })
    .catch(e => {
      jsConn.apiCallStatus = 'error'
      jsConn.error = e
      return Promise.resolve(jsConn)
    })
}

export default {
  verifyEmail,
  createUser,
  createCompanySubscription,
  getDefaultCompanyData,
  getUserCompanyData,
  signInUser,
  updateSession,
  deleteSession,
  createFertilizer,
  updateFertilizer,
  deleteFertilizer,
  createChemical,
  updateChemical,
  deleteChemical,
  createCustomRate,
  updateCustomRate,
  deleteCustomRate,
  createOtherExpense,
  updateOtherExpense,
  deleteOtherExpense,
  createSeed,
  updateSeed,
  deleteSeed,
  createIrrigation,
  updateIrrigation,
  deleteIrrigation,
  createCommodity,
  updateCommodity,
  deleteCommodity,
  createOtherIncome,
  updateOtherIncome,
  deleteOtherIncome,
  createCrop,
  updateCrop,
  deleteCrop,
  createCropCommodity,
  updateCropCommodity,
  deleteCropCommodity,
  createCropOtherIncome,
  updateCropOtherIncome,
  deleteCropOtherIncome,
  createCropOtherExpense,
  updateCropOtherExpense,
  deleteCropOtherExpense,
  createCropSeed,
  updateCropSeed,
  deleteCropSeed,
  createCropCustomRate,
  updateCropCustomRate,
  deleteCropCustomRate,
  createCropChemical,
  updateCropChemical,
  deleteCropChemical,
  createCropFertilizer,
  updateCropFertilizer,
  deleteCropFertilizer,
  createCropIrrigation,
  updateCropIrrigation,
  deleteCropIrrigation
}
